// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".favs{padding:10px}.favs p a{border-bottom:1px solid hsla(0,0%,100%,.35);display:inline-block;padding-bottom:2px;transition:border-bottom .2s ease}.favs p a:hover{border-bottom:1px solid #fff}.favs h1{margin-bottom:20px}.favs .share{margin-bottom:32px;width:240px}.favs .share input{left:-9999px;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
